export enum Roles {
  anonymous = 'anonymous',
  authenticated = 'authenticated',
  admin = 'admin',
}
